module.exports = __webpack_public_path__ + "static/media/upload-material.7b8e3d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/upload-material.png
// module id = 1166
// module chunks = 110